import React, { useEffect } from "react";
import Loader from "../Utils/Loader";
import qs from "qs";
import * as api from "./../../api";

const PaymentConfirmationRedirect = ({ location, history }) => {
  useEffect(() => {
    const parsed = qs.parse(location.search, { ignoreQueryPrefix: true });
    const { merchant_order_id: orderId, solution, ...restParams } = parsed;
    const extraSearch = qs.stringify(restParams);
    const queryString = extraSearch ? `?${extraSearch}` : '';

    if (!orderId) {
      history.replace("/");
    } else {
      if (solution == "stripe") {
        api.reservations
          .checkPayment(orderId)
          .then(() => {
            history.replace(`/orders/${orderId}${queryString}`);
          })
          .catch(() => {
            history.replace(`/orders/${orderId}${queryString}`);
          });
      } else {
        history.replace(`/orders/${orderId}${queryString}`);
      }
    }
  }, []);

  return (
    <div className="payment-redirect">
      <div className="payment-redirect__loader">
        <Loader />
      </div>
    </div>
  );
};

export default PaymentConfirmationRedirect;
